/** Excel opent een CSV met dit teken vooraan als UTF-8 (anders worden é en € rommel). */
const BOM = '\uFEFF'

/** Tekst als bestand downloaden, zonder server. */
export function downloadFile(content: string, fileName: string, type: string) {
  const url = URL.createObjectURL(new Blob([content], { type }))
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.append(a)
  a.click()
  a.remove()
  // Even laten staan: sommige browsers beginnen de download pas na deze tik.
  window.setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/** Een CSV voor Excel: met BOM, zodat é en € goed staan. */
export const downloadCsv = (fileName: string, csv: string) => downloadFile(csv.startsWith(BOM) ? csv : BOM + csv, fileName, 'text/csv;charset=utf-8')
